import { Drawer } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0 !important;
  }
`;

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
export const Header = styled.div`
  padding: 24px;
  border-bottom: 1px solid ${COLORS.systemDark100};
  display: flex;
  justify-content: space-between;
`;

export const Body = styled.div`
  padding: 24px;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 24px;
  overflow: auto;
  background: ${COLORS.systemLight300};
`;

export const Actions = styled.div`
  border-top: 1px solid ${COLORS.systemDark100};
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const GeneralInfo = styled.div`
  padding: 24px;
  border-radius: 24px;
  display: grid;
  gap: 16px;
  background: ${COLORS.systemLight100};
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Field = styled.div`
  display: grid;
  gap: 4px;
`;

export const Label = styled.div`
  color: ${COLORS.systemDark200};
`;

export const Value = styled.div`
  color: ${COLORS.systemDark300};
`;
